<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>carview</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-header collapse="condense">
    <ion-toolbar>
      <ion-title size="large">carview</ion-title>
    </ion-toolbar>
  </ion-header>
</ion-content>
